import type { BagelAiFlowNodeKind } from '../types/aiFlow';

/** Single source of truth for how each node kind is labeled across the AI Flow UI. */
const FLOW_NODE_KIND_LABEL: Record<BagelAiFlowNodeKind, string> = {
  input: 'Input',
  output: 'Output',
  gate: 'Gate',
  'human-gate': 'Human gate',
  skill: 'Skill',
  tools: 'Tools',
  prompt: 'Prompt',
};

export default FLOW_NODE_KIND_LABEL;
